let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fqWk5")).then(() => parcelRequire('cgNt3'));